module.exports = __webpack_public_path__ + "static/media/trolly-stop.368eca9b.png";